import React, {FC} from "react";
import {
    Box,
    IconButton,
    Tooltip,
} from "@mui/material";
import {List} from "@mui/icons-material";
import {Locale} from "../../locales/Locale";
import {IdlocaGeneric} from "../../locales/IdlocaGeneric";
import {Link} from "react-router-dom";

interface IViewCompareList {
    navigateToComparePath: string;
    isListAvailable: boolean;
    mobileMode: boolean;
}

export const ViewCompareList: FC<IViewCompareList> = ({
    navigateToComparePath,
    isListAvailable,
    mobileMode,
}) => {
    return (
        <Tooltip title={<Locale localeId={IdlocaGeneric.view_compare_list}/>} arrow>
            <Box
                sx={{
                    display: "inline-block",
                    "&:hover .details-button": {opacity: 1, transform: "translateY(0)"},
                }}
            >
                <Link to={navigateToComparePath} style={{textDecoration: "none"}}>
                    <IconButton
                        color={isListAvailable ? "primary" : "default"}
                        aria-label="view compare list"
                        sx={{
                            transition: "opacity 0.3s, transform 0.3s",
                            opacity: mobileMode ? 1 : 0,
                            transform: mobileMode ? "translateY(0)" : "translateY(-10px)",
                        }}
                        disabled={!isListAvailable}
                    >
                        <List/>
                    </IconButton>
                </Link>
            </Box>
        </Tooltip>
    );
};
